import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, ExpandIcon, CloseIcon } from '../Icons/Icons';
import LazyImage from '../LazyImage/LazyImage';
import './ImageGallery.css';

function ImageGallery({ images }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const nextImage = () => {
    setSelectedIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevImage = () => {
    setSelectedIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') prevImage();
    if (e.key === 'ArrowRight') nextImage();
    if (e.key === 'Escape') setIsFullscreen(false);
  };

  return (
    <>
      <div className="image-gallery">
        <div className="main-image-container">
          <LazyImage
            src={images[selectedIndex]}
            alt={`Property ${selectedIndex + 1}`}
            className="main-image"
            aspectRatio="16/9"
            style={{ cursor: 'pointer' }}
            onClick={() => setIsFullscreen(true)}
          />

          {images.length > 1 && (
            <>
              <button className="gallery-nav prev" onClick={prevImage} aria-label="Previous image">
                <ChevronLeftIcon size={24} color="white" />
              </button>
              <button className="gallery-nav next" onClick={nextImage} aria-label="Next image">
                <ChevronRightIcon size={24} color="white" />
              </button>
              <div className="image-counter">
                {selectedIndex + 1} / {images.length}
              </div>
            </>
          )}

          <button className="btn-fullscreen" onClick={() => setIsFullscreen(true)} aria-label="View fullscreen">
            <ExpandIcon size={20} color="white" />
          </button>
        </div>

        {images.length > 1 && (
          <div className="thumbnails-container">
            {images.map((image, index) => (
              <div
                key={index}
                className={`thumbnail ${index === selectedIndex ? 'active' : ''}`}
                onClick={() => setSelectedIndex(index)}
              >
                <LazyImage
                  src={image}
                  alt={`Thumbnail ${index + 1}`}
                  aspectRatio="4/3"
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {isFullscreen && (
        <div
          className="fullscreen-gallery"
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          <div className="fullscreen-overlay" onClick={() => setIsFullscreen(false)} />
          <div className="fullscreen-content">
            <button className="btn-close-fullscreen" onClick={() => setIsFullscreen(false)} aria-label="Close fullscreen">
              <CloseIcon size={32} color="white" />
            </button>

            <img
              src={images[selectedIndex]}
              alt={`Property ${selectedIndex + 1}`}
              className="fullscreen-image"
            />

            {images.length > 1 && (
              <>
                <button className="fullscreen-nav prev" onClick={prevImage} aria-label="Previous image">
                  <ChevronLeftIcon size={40} color="white" />
                </button>
                <button className="fullscreen-nav next" onClick={nextImage} aria-label="Next image">
                  <ChevronRightIcon size={40} color="white" />
                </button>
                <div className="fullscreen-counter">
                  {selectedIndex + 1} / {images.length}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ImageGallery;
